import React from "react";

export type ShowRetry = (callback: () => void, message?: string) => void;

export interface RetryContextValue {
  showRetry: ShowRetry;
  showRetryCancellable: ShowRetry;
}

export const RetryContext = React.createContext<RetryContextValue>(null!);
